var h = Object.freeze, g = Object.defineProperty;
var a = (t, o) => h(g(t, "raw", { value: h(o || t.slice()) }));
import { L as k } from "./lds-element-4P-EWHZh.js";
import { i as b, x as v } from "./lit-element-CwWchyls.js";
import { n } from "./property-EvzlnPW3.js";
import { o as y } from "./style-map-C1MKKVdB.js";
function C(t, o) {
  const i = (l) => {
    l.composedPath().includes(t) || l.composedPath().includes(t.getRootNode().host) || o(l);
  };
  return window.addEventListener("click", i), i;
}
function w(t) {
  window.removeEventListener("click", t);
}
var f;
const O = b(f || (f = a(["\n    .dropdown {\n        display: none;\n        position: absolute;\n        border-radius: var(--lds-border-radius);\n        box-shadow: var(--lds-box-shadow);\n        width: max-content;\n        background: var(--lds-dropdown-bg);\n        z-index: var(--lds-dropdown-z-index);\n        max-height: var(--lds-dropdown-max-height);\n        overflow-y: auto;\n    }\n\n    .dropdown ::slotted(*) {\n        border-radius: var(--lds-border-radius);\n    }\n\n    .trigger {\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .base {\n        position: relative;\n    }\n\n    :host {\n        display: inline-block;\n    }\n"])));
var x = Object.defineProperty, r = (t, o, i, l) => {
  for (var s = void 0, d = t.length - 1, p; d >= 0; d--)
    (p = t[d]) && (s = p(o, i, s) || s);
  return s && x(o, i, s), s;
}, u;
const c = class c extends k {
  constructor() {
    super(...arguments), this.role = "group", this.open = !1, this.stayOpenOnClick = !1, this.position = "right", this.offsetT = "0", this.clickCallback = () => {
    }, this.onClick = () => {
      this.open = !this.open, this.emitChange();
    };
  }
  firstUpdated() {
    this.clickCallback = C(this, () => {
      this.close();
    });
  }
  onContentClick() {
    this.stayOpenOnClick || this.close();
  }
  close() {
    this.open = !1, this.emitChange();
  }
  emitChange() {
    this.emit("change", this.open);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), w(this.clickCallback);
  }
  render() {
    return v(u || (u = a(['\n            <div class="base">\n                <slot class="trigger" name="trigger" part="trigger" @click=', '></slot>\n                <div\n                    class="dropdown"\n                    part="dropdown"\n                    style=', ">\n                    <slot @click=", "></slot>\n                </div>\n            </div>\n        "])), this.onClick, y({
      display: this.open ? "flex" : "none",
      right: this.position === "left" ? "0" : "auto",
      "margin-top": this.offsetT
    }), this.onContentClick);
  }
};
c.styles = O;
let e = c;
r([
  n({ type: String, reflect: !0 })
], e.prototype, "role");
r([
  n({ type: Boolean, reflect: !0 })
], e.prototype, "open");
r([
  n({ type: Boolean, attribute: "stay-open-on-click" })
], e.prototype, "stayOpenOnClick");
r([
  n({ type: String })
], e.prototype, "position");
r([
  n({ type: String, attribute: "offset-top" })
], e.prototype, "offsetT");
const m = new URL(import.meta.url), E = m.searchParams.has("debug");
if (!m.searchParams.has("no-define")) {
  const t = customElements.get("lds-dropdown");
  t ? t.VERSION !== e.VERSION && E && console.log("%clds-dropdown tried loading in version ".concat(e.VERSION, ", but lds-dropdown is already defined as ").concat(t.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-dropdown", e);
}
export {
  e as LdsDropdown
};
